var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "resolution_block resolution" },
    [
      _c("r_table", {
        attrs: {
          is_load: _vm.is_load,
          items: _vm.init,
          title: "Ініціатор",
          type: "init",
        },
      }),
      _vm._v(" "),
      _c("r_table", {
        attrs: {
          is_load: _vm.is_load,
          items: _vm.adjust,
          title: "Погодження",
          type: "adjust",
        },
      }),
      _vm._v(" "),
      _c("r_table", {
        attrs: {
          is_load: _vm.is_load,
          items: _vm.recipient,
          title: "Затвердження",
          type: "rec",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "invoice_show info invoice" }, [
        _vm._v("\n        Повiдомлення\n        "),
        _c("i", {
          staticClass: "fa show_inv",
          class: _vm.invoice_class,
          on: { click: _vm.show_invoices },
        }),
      ]),
      _vm._v(" "),
      _c("r_table", {
        attrs: {
          is_load: false,
          show_head: true,
          items: _vm.invoices,
          title: "INV",
          type: "invoice",
        },
      }),
      _vm._v(" "),
      _c("r_table", {
        attrs: {
          is_load: _vm.is_load,
          items: _vm.isp,
          title: "Виконавець прийняв в роботу",
          type: "isp_accept",
        },
      }),
      _vm._v(" "),
      _vm.delegate.length > 0
        ? _c("r_table", {
            attrs: {
              is_load: _vm.is_load,
              items: _vm.delegate,
              title: "Делегування",
              type: "delegates",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("r_table", {
        attrs: {
          is_load: _vm.is_load,
          items: _vm.isp_end,
          title: "Виконавець виконав",
          type: "isp_end",
        },
      }),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "table-striped table resolution table-responsive-xl" },
        [
          _c("tbody", [
            _c("tr", { staticClass: "info" }, [
              _c("td", { attrs: { colspan: "4" } }, [_vm._v("Всього")]),
              _vm._v(" "),
              _c("td", { staticClass: "user_time" }, [
                _vm._v(_vm._s(_vm.full_time)),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }